import { FC } from 'react';
import { IconPath, IconSVG, IconSVGComponentProps } from '../IconComponent';

export const Tobacco: FC<IconSVGComponentProps> = ({ pathProps, ...props }) => {
    return (
        <IconSVG strokeWidth={0} {...props}>
            <IconPath
                fill="currentColor"
                fillRule="evenodd"
                d="M19.783 15.36h-1.776c-.37 0-.74-.259-.777-.629-.074-.443.296-.851.74-.851h1.85c.296 0 .555-.074.74-.259a.703.703 0 0 0 .184-.481c0-.37-.258-.74-.924-.74h-1.85c-1.592 0-2.405-1.11-2.405-2.22 0-.593.222-1.148.628-1.554.26-.296.853-.666 1.74-.666h2.96c.297 0 .555-.074.74-.259a.703.703 0 0 0 .185-.481c0-.37-.258-.74-.925-.74h-5.106c-.37 0-.74-.259-.778-.629-.073-.443.297-.851.74-.851h5.18c1.592 0 2.405 1.11 2.405 2.22 0 .593-.222 1.148-.628 1.554-.37.296-.925.666-1.813.666h-2.96c-.332 0-.555.074-.74.259a.703.703 0 0 0-.185.481c0 .332.259.74.925.74h1.85c1.592 0 2.405 1.11 2.405 2.22 0 .593-.222 1.148-.628 1.554a2.567 2.567 0 0 1-1.777.666ZM1.5 17.5v3h4.25v-3H1.5Zm5.75 0v3H20.5v-3H7.25ZM.5 16a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 .5.5h21a.5.5 0 0 0 .5-.5v-5a.5.5 0 0 0-.5-.5H.5Z"
                clipRule="evenodd"
                {...pathProps}
            />
        </IconSVG>
    );
};
